import React from 'react';
import { XIcon } from 'lucide-react';
import { failedAttempts } from '../data/landing';
export function Diagnosis() {
  return <section className="w-full border-y border-teal/10 bg-paper py-16 lg:py-24" data-id="element-45" data-mp="w7g0ajgw8nca">
      <div className="mx-auto max-w-readable px-6" data-id="element-46" data-mp="118vje5zigjs1">
        <p className="font-serif text-2xl italic leading-relaxed text-teal-dark sm:text-3xl" data-id="element-47" data-mp="115zluirkrx44">
          Usted conoce esa sensación.
        </p>
        <div className="mt-6 space-y-6 font-sans text-xl leading-relaxed text-ink sm:text-[1.375rem]" data-id="element-48" data-mp="8k7s9ts2z06k">
          <p data-id="element-49" data-mp="djawxd45f4e0">
            Abre los ojos, intenta salir de la cama y sus rodillas se sienten
            como cristal roto. Ese primer paso hacia el baño es una prueba de
            fuego, y sus manos parecen pertenecerle a alguien más debido a la
            hinchazón.
          </p>
          <p data-id="element-50" data-mp="3lyunu5hckapw">
            Durante años le han dicho que <em data-id="element-51" data-mp="3lxt1v5ysm3te">“es normal por la edad”</em>. Pero
            la verdad es que su cuerpo no está viejo,{' '}
            <strong className="font-semibold text-clay" data-id="element-52" data-mp="3qv1iv387g1t2">
              simplemente está incendiado por dentro
            </strong>
            .
          </p>
        </div>

        <h2 className="mt-16 font-serif text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-53" data-mp="23nrf86bh5zl0">
          El dolor no viene de sus huesos
        </h2>
        <div className="mt-6 space-y-6 font-sans text-xl leading-relaxed text-inkSoft sm:text-[1.375rem]" data-id="element-54" data-mp="1txpo15nts11v">
          <p data-id="element-55" data-mp="1pwdyf04ybfto">
            La medicina tradicional suele tratar el dolor articular con parches:
            pastillas que dañan su estómago, cremas que solo huelen fuerte y la
            resignación de que “debe acostumbrarse”.
          </p>
          <p data-id="element-56" data-mp="1fy6rzb8agg5x">
            Lo que nadie le dice es que el dolor no es causado por sus huesos,
            sino por un <strong className="text-ink" data-id="element-57" data-mp="1b0epxodxjdo0">líquido sinovial</strong>{' '}
            que se ha vuelto espeso y ácido. Es como intentar arrancar un coche
            que no tiene aceite. Si no limpia ese “pegamento” celular, ningún
            analgésico la hará sentir joven otra vez.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-16 max-w-readable px-6" data-id="element-58" data-mp="13lma7cfbnsmu">
        <h3 className="font-serif text-2xl font-semibold text-ink sm:text-3xl" data-id="element-59" data-mp="18exkxon98tk1">
          Por qué lo que ya intentó no funcionó
        </h3>
        <ul className="mt-8 divide-y divide-teal/10 border-t border-teal/10" data-id="element-60" data-mp="tnezhbbmm6ta">
          {failedAttempts.map(item => <li key={item.title} className="flex gap-5 py-6" data-id="element-61" data-mp="1mdf5xelrzry9">
              <XIcon className="mt-1 h-7 w-7 flex-none text-clay" aria-hidden="true" data-id="element-62" data-mp="1mbu7vf095qvn" />
              <p className="font-sans text-xl leading-relaxed text-inkSoft" data-id="element-63" data-mp="1dds26m5kqa21">
                <strong className="font-semibold text-ink" data-id="element-64" data-mp="1heu3d8j1ww6n">
                  {item.title}:
                </strong>{' '}
                {item.text}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}